function PeopleCellRenderer(params) {
  const celldata = params.users;
  if (celldata && params.value) {
    const cellvalue = params.value ? params.value : "";

    if (celldata.hasOwnProperty(cellvalue)) {
      const data = celldata[cellvalue];
      const name = data?.name;
      // let lastname = name.length > 10 ? `${name.slice(0, 10)} ...` : name;
      if (data) {
        if (
          params.data.completed === "true" ||
          params.data.completed === true
        ) {
          return (
            <span className="strike-out">
              {data.profile_image && (
                <img src={data.profile_image} className="rounded-circle rci" />
              )}
              &nbsp;
              {name}
            </span>
          );
        }
        return (
          <span>
            {data.profile_image && (
              <img src={data.profile_image} className="rounded-circle rci" />
            )}
            &nbsp;
            {name}
          </span>
        );
      }
    } else {
      if (params.value) {
        if (
          params.data.completed === "true" ||
          params.data.completed === true
        ) {
          return (
            <span className="strike-out">
              {params.value.profile_pic && (
                <img
                  src={params.value.profile_pic}
                  className="rounded-circle rci"
                />
              )}
              &nbsp;
              {params.value.name}
            </span>
          );
        }
        return (
          <span>
            {params.value.profile_pic && (
              <img
                src={params.value.profile_pic}
                className="rounded-circle rci"
              />
            )}
            &nbsp;
            {params.value.name}
          </span>
        );
      }
    }
  } else {
    if (params.value) {
      const options =
        params.columnApi?.columnModel?.rowGroupColumns?.[0]?.colDef?.options;
      if (options) {
        return options?.[params.value]?.name;
      }
    } else return params.value;
  }
}

export default PeopleCellRenderer;
